/**
 * Gets the base URL for images based on the environment
 * @returns {string} The base URL for images
 */
export const getImageBaseURL = () => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:3005'
    : window.location.origin;
};

/**
 * Transforms any image URL to use the correct domain based on environment
 * @param {string} imagePath - The image path or URL
 * @returns {string} The complete image URL with the correct domain
 */
export const getImageURL = (imagePath) => {
  if (!imagePath) return '';
  
  // Extract just the filename or path portion after /uploads/
  let uploadsPath = '';
  
  // If it's a full URL with localhost, extract just the path after /uploads/
  if (imagePath.includes('/uploads/')) {
    const uploadsPart = imagePath.split('/uploads/')[1];
    uploadsPath = `/uploads/${uploadsPart}`;
  } else {
    // Assume it's just a filename
    uploadsPath = `/uploads/${imagePath}`;
  }
  
  // Return the complete URL with the correct base
  return `${getImageBaseURL()}${uploadsPath}`;
};
